var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartBar',{staticClass:"bar-chart",attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptionsComputed,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }